'use strict'

import Vue from 'vue'
import Router from 'vue-router'
import takeOffTool from './take-off-tool'
import project from './project'
import projectAudit from './project-audit'
import checkout from './checkout'
import login from './login'
import myAccount from './my-account'
import pageNotFound from './page-not-found'
import store from 'CommonApp/store'

const appRoutes = [
	{
		path: '/',
		name: 'Main',
		redirect: {
			name: 'project.list'
		}
	},
	{ path: '*', component: pageNotFound }
].concat(login, project, takeOffTool, projectAudit, checkout, myAccount)

const appRouter = new Router({ mode: 'history', routes: appRoutes })

appRouter.beforeEach((to, from, next) => {
	console.debug('router before each from', from, 'to', to)

	// Ensure conig load before accessing any route
	const config = Vue.e24Common.configService
	config.load(config.APP).then(() => {
		if (to.matched.some(record => record.meta.authRequired)) {
			// this route requires auth, check if logged in
			// if not, redirect to login page.
			Vue.e24.security.requestCurrentUser().then((currentUser) => {
				if (!Vue.e24.security.isAuthenticated()) {
					// Store requested url to use after login or user register
					store.dispatch({
						type: 'updateEntryUrl',
						value: to.path
					})

					next({
						name: 'connect',
						params: { goodbye: false, redirect: '', error: '' }
					})
				} else {
					// Ensure that janux storage service has current username
					Vue.jnx.storageService.setUsername(currentUser.username)

					const activeProject = Vue.jnx.storageService.findItem('activeProject', true)
					store.dispatch({
						type: 'updateActiveProject',
						value: activeProject
					})
					const lastOrder = Vue.jnx.storageService.findItem('lastOrder', true)
					store.dispatch({
						type: 'updateLastOrder',
						value: lastOrder
					})
					next()
				}
			})
		} else {
			next() // make sure to always call next()!
		}
	})
})

export default appRouter



// WEBPACK FOOTER //
// ./src/app/router.js